<script setup lang="ts">
import { computed } from "vue";
import { definePage } from "unplugin-vue-router/runtime";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

definePage({
  meta: {
    title: "models.invitations.error.title",
    requiresAuth: false,
    layout: "public",
  },
});

const { t } = useI18n();
const route = useRoute();

const is404 = computed(() => route.query.status === "404");
const description = computed(() =>
  is404.value ? t("models.invitations.error.notFound") : t("models.invitations.error.description")
);
</script>

<template>
  <div
    class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-full tw:gap-4 tw:text-center tw:px-4"
  >
    <v-icon
      icon="mdi-alert-circle-outline"
      size="64"
      color="error"
    />
    <h1 class="tw:text-2xl tw:font-bold tw:text-on-surface">
      {{ t("models.invitations.error.title") }}
    </h1>
    <p class="tw:text-on-surface/60">
      {{ description }}
    </p>
  </div>
</template>
